export default {
  pPlaterApproved: 'P-Plate Approved',
  safeCarsForFamilies: 'Safe Cars for Families',
};
